// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundLogoIcon__logo-f97a2d {
  position: absolute;
  inset-inline-start: 56px;
  top: 24px;
}

@media (max-width: 1024px) {
  .BackgroundLogoIcon__logo-f97a2d {
    inset-inline-start: 36px;
  }
}
@media (max-width: 428px) {
  .BackgroundLogoIcon__logo-f97a2d {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/Pages/Components/BackgroundLogoIcon/BackgroundLogoIcon.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,wBAAA;EACA,SAAA;AACF;;AAEA;EACE;IACE,wBAAA;EACF;AACF;AAEA;EACE;IACE,aAAA;EAAF;AACF","sourcesContent":[".logo {\n  position: absolute;\n  inset-inline-start: 56px;\n  top: 24px;\n}\n\n@media (max-width: 1024px) {\n  .logo {\n    inset-inline-start: 36px;\n  }\n}\n\n@media (max-width: 428px) {\n  .logo {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `BackgroundLogoIcon__logo-f97a2d`
};
module.exports = ___CSS_LOADER_EXPORT___;
